import type { CreateSessionLogStreamParams } from "@/services/opsmate/sessionLog";

export interface QuestionScopeParams {
  references?: Array<{ references_document_id: string }>;
  OnlyUseSelectedSources: boolean;
  DocCategoryIds: string[];
  StudySourceIds: string[];
  IncludePersonalDocs: boolean;
}

export function buildCreateSessionLogParams({
  question,
  conversationId,
  historySessionLogIdList,
  questionScopeParams,
}: {
  question: string;
  conversationId?: string | null;
  historySessionLogIdList: string[];
  questionScopeParams: QuestionScopeParams;
}): CreateSessionLogStreamParams {
  return {
    question,
    conversationId,
    HistorySessionLogIdList: historySessionLogIdList,
    ...questionScopeParams,
  };
}

export function normalizeSelectedDocumentIds(documentIds: string[]): string[] {
  return Array.from(new Set(documentIds.map((id) => id.trim()).filter(Boolean)));
}

export function canSubmitQuestionScope(
  onlyUseSelectedSources: boolean,
  selectedSourceGuidNames: string[],
): boolean {
  return (
    !onlyUseSelectedSources || normalizeSelectedDocumentIds(selectedSourceGuidNames).length > 0
  );
}

export function buildQuestionScopeParams({
  onlyUseSelectedSources,
  selectedSourceGuidNames,
  docCategoryIds,
  studySourceIds,
  includePersonalDocs,
}: {
  onlyUseSelectedSources: boolean;
  selectedSourceGuidNames: string[];
  docCategoryIds: string[];
  studySourceIds: string[];
  includePersonalDocs: boolean;
}): QuestionScopeParams {
  const documentIds = normalizeSelectedDocumentIds(selectedSourceGuidNames);

  return {
    ...(documentIds.length > 0
      ? {
          references: documentIds.map((id) => ({ references_document_id: id })),
        }
      : {}),
    OnlyUseSelectedSources: onlyUseSelectedSources,
    // “仅使用选定文档”开启时，底部三个库范围不参与本次请求。
    DocCategoryIds: onlyUseSelectedSources ? [] : [...new Set(docCategoryIds)],
    StudySourceIds: onlyUseSelectedSources ? [] : [...new Set(studySourceIds)],
    IncludePersonalDocs: onlyUseSelectedSources ? false : includePersonalDocs,
  };
}
